package one.devsbox.www.ui.devices

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.provider.LocalPreferencesProvider
import one.devsbox.www.provider.MeProvider
import one.devsbox.www.provider.PreferencesProvider
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.viewModel

class ListingDevicesCtx private constructor(
    val vm: ListingDevicesVM,
    val nav: Navigation,
    val me: MeProvider,
    val prefs: PreferencesProvider,
    val colorPrimaryContainer: Color,
    val colorSecondaryContainer: Color
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): ListingDevicesCtx {
            val nav = LocalNavigation.current
            val vm = nav.viewModel(ListingDevicesVM::class)
            val me = LocalMeProvider.current
            val prefs = LocalPreferencesProvider.current
            val colorPrimary = MaterialTheme.colorScheme.primary
            val colorSecondary = MaterialTheme.colorScheme.secondary
            return remember {
                ListingDevicesCtx(vm, nav, me, prefs, colorPrimary, colorSecondary).apply {
                    vm.setup(this)
                }
            }
        }
    }
}

